import { ExternalScript } from '../store/config/config.reducer';

const CWV_SITE_SAMPLING_RATES: Record<string, number> = {
  'apptrigger.com': 50,
  'arrowheadaddict.com': 50,
  'bamsmackpow.com': 50,
  'beyondtheflag.com': 50,
  'bluemanhoop.com': 50,
  'causewaycrowd.com': 50,
  'dailyddt.com': 50,
  'dawnofthedawg.com': 50,
  'detroitjockcity.com': 50,
  'editorinleaf.com': 50,
  'fansided.com': 40,
  'foodsided.com': 50,
  'geeksided.com': 50,
  'hotspurhq.com': 50,
  'kckingdom.com': 50,
  'keepingitheel.com': 50,
  'lakeshowlife.com': 50,
  'octopusthrower.com': 50,
  'progolfnow.com': 50,
  'redbirdrants.com': 50,
  'riggosrag.com': 50,
  'risingapple.com': 50,
  'saintsmarching.com': 50,
  'saturdayblitz.com': 50,
  'section215.com': 50,
  'showsnob.com': 50,
  'thecelticbhoys.com': 50,
  'thelandryhat.com': 50,
  'theparentwatch.com': 50,
  'thesmokingcuban.com': 50,
  'winteriscoming.net': 50,
  'www.fansided2030.com': 50,
  'www.si.com': 25,
  'yanksgoyard.com': 50,
};

export function getCWVScript(canonicalURL: string): ExternalScript | null {
  let samplePercentage = 0;

  try {
    const url = new URL(canonicalURL);
    const { hostname } = url;

    if (hostname in CWV_SITE_SAMPLING_RATES) {
      samplePercentage = CWV_SITE_SAMPLING_RATES[hostname];
    }
  } catch (error) {
    return null;
  }

  if (samplePercentage > 0) {
    return {
      type: 'code',
      source: `
          (function () {
            const SAMPLE_PERCENTAGE = ${samplePercentage};
            if (Math.random() < SAMPLE_PERCENTAGE / 100) {
              const script = document.createElement("script");
              script.src =
                "https://assets.minutemediacdn.com/mm-cwv-tracker/prod/mm-cwv-tracker.js";
              script.async = true;
              document.head.appendChild(script);
            }
          })();
        `,
      name: 'cwv-tracker',
      attributes: null,
      loadingType: 'async',
    };
  }

  return null;
}
